import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { Typography, Button, TextField, Pagination } from '@mui/material';

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import TituloPagina2 from "conten/components/TituloPagina2";
import { Box, Collapse, Divider, Grid, Paper } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { addMessage } from "conten/mensajes/MessagesActions";
import { connect } from "react-redux";
import MesaDeAyudaApiHelper from "./MesaDeAyudaApiHelper";
import { ID_CUENTA } from "config/general/Configuracion";
import { ID_PERFIL } from "config/general/Configuracion";
import { NOMBREAPELLIDOUSUARIO } from "config/general/Configuracion";


const MesaDeAyuda = ({ classes, addMessage }) => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroPrioridad, setFiltroPrioridad] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("");
  const [filtroArea, setFiltroArea] = useState("");
  const [expandidoId, setExpandidoId] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const elementosPorPagina = 5;
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [dropzoneKey, setDropzoneKey] = useState(Date.now());

  const [nuevaSolicitud, setNuevaSolicitud] = useState({
    prioridad: "",
    tipo_solicitud: "",
    descripcion_solicitud: "",
    area_a_resolver: "",
    enlace_imagenes_evidencia_solicitud: ""
  });

  const toggleExpand = (id) => {
    setExpandidoId(expandidoId === id ? null : id);
  };

  const handleNuevaSolicitudChange = (campo, valor) => {
    setNuevaSolicitud((prev) => ({ ...prev, [campo]: valor }));
  };

  const filtrarSolicitudes = () => {
    return solicitudes.filter((solicitud) => {
      const coincideTexto = solicitud.descripcion_solicitud.toLowerCase().includes(filtro.toLowerCase());
      const coincideTipo = !filtroTipo || solicitud.tipo_solicitud === parseInt(filtroTipo);
      const coincideEstado = !filtroEstado || solicitud.estado_solicitud === parseInt(filtroEstado);

      return coincideTexto && coincideTipo && coincideEstado;
    });
  };

  const obtenerSolicitudesPaginadas = () => {
    const todas = filtrarSolicitudes();
    const inicio = (paginaActual - 1) * elementosPorPagina;
    const fin = inicio + elementosPorPagina;
    return todas.slice(inicio, fin);
  };

  const totalPaginas = Math.ceil(filtrarSolicitudes().length / elementosPorPagina);
  const cuentaId = localStorage.getItem("cuenta");
  const usuarioId = localStorage.getItem("ID_USUARIO");

  const handleCrearSolicitud = async () => {
    if (
      nuevaSolicitud.descripcion_solicitud
    ) {
      try {
        const idUsuario = localStorage.getItem("ID_USUARIO") || await obtenerIdUsuario();
        const nueva = {
          prioridad: 3,
          tipo_solicitud: 5,
          descripcion_solicitud: nuevaSolicitud.descripcion_solicitud,
          usuario_solicita: idUsuario,
          area_a_resolver: 9,
          estado_solicitud: 1,
          descripcion_solucion: "",
          enlace_imagenes_evidencia_solicitud: nuevaSolicitud.enlace_imagenes_evidencia_solicitud || "",
          enlace_imagenes_evidencia_solucion: ""
        };

        const cuenta = localStorage[ID_CUENTA];
        await MesaDeAyudaApiHelper.guardarSolicitud(cuenta, nueva);

        const usuario = await MesaDeAyudaApiHelper.obtenerIdUsuario();
        const response = await MesaDeAyudaApiHelper.listarSolicitudes(cuentaId, usuario, 100, 1);
        setSolicitudes(response.solicitudes);

        const ultima = response.solicitudes[0];
        setExpandidoId(ultima.id);

        setNuevaSolicitud({
          prioridad: "",
          tipo_solicitud: "",
          descripcion_solicitud: "",
          area_a_resolver: "",
          enlace_imagenes_evidencia_solicitud: ""
        });
        setDropzoneKey(Date.now());
        setMostrarFormulario(false);
        setPaginaActual(1);

        setPaginaActual(1);

      
        addMessage({
          variant: "success",
          message: `🎉 Gracias por tu aporte, ${localStorage[NOMBREAPELLIDOUSUARIO]} 🙌. Lo estamos revisando.`,
        });
      } catch (error) {
        console.error("Error al guardar la solicitud:", error);
        addMessage({
          variant: "danger",
          message: `Ocurrió un error al crear la solicitud. Por favor intenta de nuevo.`,
        });
      }
    } else {
      addMessage({
        variant: "warning",
        message: `Por favor completa todos los campos obligatorios para crear la solicitud.`,
      });
    }
  };

  useEffect(() => {
    setPaginaActual(1);
  }, [filtro, filtroTipo, filtroPrioridad, filtroEstado, filtroArea]);

  const listarSolicitudesdDesdeApi = async () => {

    MesaDeAyudaApiHelper.obtenerIdUsuario()
      .then((usuarioId) => {
        MesaDeAyudaApiHelper.listarSolicitudes(cuentaId, usuarioId, 100, paginaActual)
          .then((response) => {
            setSolicitudes(response.solicitudes);
          })
      })
      .catch((error) => {
        console.error("Error al listar solicitudes:", error);
        addMessage({
          variant: "danger",
          message: `Error al listar solicitudes: ${error.message}`,
        });
      });
  }

  useEffect(() => {
    listarSolicitudesdDesdeApi();
  }, []);

  const estadoSolicitud = [
    { id: 1, nombre: "Nuevo" },
    { id: 2, nombre: "En progreso" },
    { id: 3, nombre: "Resuelto" },
  ];

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleDropzoneChange = async (files) => {
    if (files.length > 0) {
      const base64List = await Promise.all(files.map(file => toBase64(file)));
      const concatenado = base64List.join(';');
      handleNuevaSolicitudChange("enlace_imagenes_evidencia_solicitud", concatenado);
    } else {
      handleNuevaSolicitudChange("enlace_imagenes_evidencia_solicitud", '');
    }
  };

  const styles = theme => ({
    ...extendedTablesStyle,
    dropzoneText: {
      fontSize: "0.85rem",
      color: "#555",
      textAlign: "center",
      marginTop: "8px",
    }
  });
  const emojiIcon = (emoji) => () => (
  <div
    style={{
      fontSize: '20px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 20,
      height: 20,
      lineHeight: 1,
    }}
  >
    {emoji}
  </div>
);

  const esBase64 = (cadena) =>
    cadena.startsWith("data:image");

  return (
    <GridItem xs={12}>
      <Card style={{ marginTop: '45px' }}>
        <CardHeader icon>
          <CardIcon color="primary">
              { emojiIcon('💬')() }
          </CardIcon>
          <TituloPagina2
            texto='Ayúdanos a mejorar'
            color='primary'
            classes={classes}
            style={{ height: "30px", display: "block", lineHeight: "30px" }}

          />
        </CardHeader>
        <CardBody>
          <Grid container spacing={2} style={{ marginBottom: "1rem" }}>
            <Grid item xs={12} md={12}>
              <TextField
                label="🔍 Buscar por palabra clave"
                placeholder="Ej: error en descarga, mejora visual..."
                variant="outlined"
                fullWidth
                size="small"
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={12}>
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                label="Estado de tu solicitud"
                select
                fullWidth
                size="small"
                value={filtroEstado}
                onChange={(e) => setFiltroEstado(e.target.value)}
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
              >
                <option value="">Sin filtro</option>
                {estadoSolicitud.map((op) => (
                  <option key={op.id} value={op.id}>{op.nombre}</option>
                ))}
              </TextField>
            </Grid>
            <Typography variant="subtitle2" gutterBottom>¿Tuviste un problema o se te ocurrió una mejora? ¡Aquí puedes contárnoslo!</Typography>
          </Grid>
          {["101", "102", "106", "107"].includes(localStorage[ID_PERFIL]) && (
            <Button
              fullWidth
              variant="contained"
              style={{
                backgroundColor: "#162F4A",
                color: "#f0f4f8",
                marginBottom: "1rem",
                borderRadius: "6px",
                boxShadow: "none",
                textTransform: "none",
                fontWeight: "bold"
              }}
              onClick={() => setMostrarFormulario(!mostrarFormulario)}
              endIcon={mostrarFormulario ? <ExpandLess /> : <ExpandMore />}
            >
              {mostrarFormulario ? "Cerrar" : "📝 Quiero reportar algo"}
            </Button>)}
          <Collapse in={mostrarFormulario}>
            <Paper
              elevation={1}
              style={{
                padding: "1rem",
                marginBottom: "1rem",
                border: "1px dashed #aaa",
                backgroundColor: "#f0f4f8"
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>

                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label="¿Qué pasó o qué mejorarías?"
                    multiline
                    rows={2}
                    fullWidth
                    size="small"
                    value={nuevaSolicitud.descripcion_solicitud}
                    onChange={(e) => handleNuevaSolicitudChange("descripcion_solicitud", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <DropzoneArea
                    key={dropzoneKey}
                    acceptedFiles={['image/*']}
                    dropzoneText={<span style={{ fontSize: "1rem" }}>📷 Adjunta una imagen (opcional) que nos ayude a entender mejor tu solicitud.</span>}

                    filesLimit={1}
                    onChange={handleDropzoneChange}
                    showAlerts={false}
                    useChipsForPreview={true}
                    maxFileSize={5000000} // 5MB
                    showPreviewsInDropzone={true}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleCrearSolicitud}
                    style={{ height: "100%", backgroundColor: "#162F4A", color: "white" }}
                  >
                    🚀 Enviar solicitud
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Collapse>
          {filtrarSolicitudes().length > 0 && (
            <Box mb={2}>
              <Typography variant="body1" style={{ color: "#555" }}>
                👀 Estas son tus ideas, reportes y sugerencias. ¡Gracias por confiar en nosotros!
              </Typography>
            </Box>
          )}
          {obtenerSolicitudesPaginadas().map((solicitud, index) => (

            <Paper
              key={solicitud.id}
              elevation={0}
              style={{
                padding: "1rem",
                backgroundColor: index % 2 === 1 ? "#f1f5f9" : "#ffffff"
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Typography variant="body2" color="textSecondary">
                    solicitud por: {solicitud.nombre_usuario_solicita}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Fecha: {new Date(solicitud.fecha_solicitud).toLocaleString()}
                  </Typography>

                </Grid>
                <Grid item xs={12} md={3}> 
                  <Button
                    size="small"
                    variant="contained"
                    style={{
                      backgroundColor: "#162F4A",
                      color: "white",

                    }}
                    onClick={() => toggleExpand(solicitud.id)}
                    endIcon={expandidoId === solicitud.id ? <ExpandLess /> : <ExpandMore />}
                  >
                    {expandidoId === solicitud.id ? "🔼 Ocultar respuesta" : "🔍 Ver más detalles"}
                  </Button>
                </Grid>
              </Grid>

              <Collapse in={expandidoId === solicitud.id}>
                <Divider style={{ margin: "1rem 0" }} />
                <Typography variant="subtitle2">{solicitud.descripcion_solicitud}</Typography>
                {solicitud.enlace_imagenes_evidencia_solicitud && (
                  esBase64(solicitud.enlace_imagenes_evidencia_solicitud) ? (
                    <Box mt={1}>
                      <Typography variant="subtitle2">Imagen de solicitud:</Typography>
                      <img
                        src={solicitud.enlace_imagenes_evidencia_solicitud}
                        alt="Evidencia"
                        style={{ maxWidth: "100%", maxHeight: 300, marginTop: "0.5rem", borderRadius: "4px" }}
                      />
                    </Box>
                  ) : (
                    <Box mt={1}>
                      <Typography variant="subtitle2">Enlace de imagen:</Typography>
                      <a
                        href={solicitud.enlace_imagenes_evidencia_solicitud}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1a73e8", textDecoration: "underline" }}
                      >
                        Ver imagen de solicitud
                      </a>
                    </Box>
                  )
                )}
                <Box marginTop={2}>
                  <Typography variant="subtitle2">¿Cómo lo solucionamos?</Typography>
                  <Typography variant="body2">
                    {solicitud.descripcion_solucion || "🚧 Estamos trabajando en esto. Pronto te daremos respuesta."}
                  </Typography>
                  {solicitud.nombre_usuario_soluciona && (
                    <Typography variant="body2" color="textSecondary">
                      ✅ Resuelto por: {solicitud.nombre_usuario_soluciona}<br />
                      📅: {new Date(solicitud.fecha_solucion).toLocaleString()}
                    </Typography>

                  )}
                  {solicitud.enlace_imagenes_evidencia_solucion && (
                    <a
                      href={solicitud.enlace_imagenes_evidencia_solucion}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#1a73e8", textDecoration: "underline" }}
                    >
                      Ver imagen de solución
                    </a>
                  )}
                </Box>
              </Collapse>
            </Paper>
          ))}
        </CardBody>
        <Box display="flex" justifyContent="center" marginTop={2} marginBottom={2}>
          <Pagination
            count={totalPaginas}
            page={paginaActual}
            onChange={(e, value) => setPaginaActual(value)}
            style={{ backgroundColor: "white", color: "#162F4A" }}
            shape="rounded"
          />
        </Box>
      </Card>
    </GridItem>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addMessage: (content) => dispatch(addMessage(content)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    null,
    mapDispatchToProps
  )(MesaDeAyuda)
);